<template v-if="storeStores.store != undefined">
    <div class="box_content p-4">
        <div>
            <BaseInput
                class="col-12 mb-3"
                label="Domínio do checkout"
                type="text"
                v-model="storeStores.store.checkout_domain"
                id="checkout_domain"
                :page="route.name"
            />
            <BaseInput
                class="col-12 mb-3"
                label="Domínio da área de membros"
                type="text"
                v-model="storeStores.store.member_domain"
                id="member_domain"
                :page="route.name"
            />
        </div>
    </div>
</template>

<script setup>
import { useStoreStore } from '@/stores/store';
import { useRoute } from 'vue-router';
const storeStores = useStoreStore();

const route = useRoute()
</script>